import styled from 'styled-components';

import { Layout } from 'antd';

export const Content = styled(Layout.Content)`
  padding: 24px;
  gap: 16px;
  flex-direction: column;
  display: flex;
  transition: all 0.2s;

  .profileContainer {
    width: 100%;
    /* div:nth-of-type(1) {
      margin-top: 0;
    } */

    /* > div:nth-of-type(2) {
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    } */
  }

  .profileInfoWrapper {
    flex-direction: column;
  }

  .mobileActionsButtonWrapper {
    button {
      margin-top: 24px;
    }
  }
`;
